module.exports = __webpack_public_path__ + "static/media/Background.5e68c33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background.png
// module id = 51
// module chunks = 0